<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">เทมเพลตของผังรายการ</div>
          </div>
          <div class="actions">
            <router-link
              :to="'/schedule-templates/create'"
              class="btn btn-primary">
              <i class="fas fa-plus icon"></i> สร้างเทมเพลต
            </router-link>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <PreloaderSection v-if="loadScheduleTemplatesState.isLoading" />
      <div v-if="!loadScheduleTemplatesState.isLoading">
        <!-- render content -->
        <Section v-if="!loadScheduleTemplatesState.error">
          <template v-slot:section-filter>
            <input
              class="form-control form-control-search"
              placeholder="ค้นหาด้วยชื่อเทมเพลต..."
              @keyup.enter.stop.prevent="onSearch" />
          </template>
          <!-- render content -->
          <template v-slot:section-body>
            <div v-if="!isEmpty()">
              <List>
                <template v-slot:list-header>
                  <div class="list-item-detail">
                    <div class="list-item list-item-primary list-item-title">ชื่อ</div>
                    <div class="list-item">สร้างเมื่อ</div>
                    <div class="list-item list-item-action"></div>
                  </div>
                </template>
                <template v-slot:list-body>
                  <div
                    class="list-item-container no-underline"
                    v-for="item in scheduleTemplates"
                    :key="item.id">
                    <div class="list-item-detail">
                      <div class="list-item list-item-primary list-item-title">
                        {{item.name}}
                      </div>
                      <div class="list-item">
                        {{formatDateTime(item.createdAt)}}
                      </div>
                      <div class="list-item list-item-action">
                        <div class="action-container">
                          <router-link
                            class="btn btn-light btn-action"
                            :to="`/schedule-templates/${item.id}`">
                            <i class="fas fa-pencil-alt"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </List>
              <div
                class="pagination-container"
                v-if="isShowPagination()">
                <Pagination :lastPage="lastPage" />
              </div>
            </div>
            <!-- search result -->
            <EmptyMessage v-if="isEmpty()">
              <h3>ไม่พบเทมเพลตที่ค้นหา</h3>
              <button
                type="button"
                class="btn btn-light btn-lg mt-4"
                @click="clearSearch">
                ล้างการค้นหา
              </button>
            </EmptyMessage>
          </template>
        </Section>
        <!-- error from api -->
        <ErrorMessageScheduleTemplateContainer
          v-if="loadScheduleTemplatesState.error"
          :error="loadScheduleTemplatesState.error"
        />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import dateFormetter from '@/utils/dateFormatter';
import Page from '@/layouts/Page.vue';
import Pagination from '@/components/Pagination.vue';
import Section from '@/components/Section.vue';
import List from '@/components/List.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';

import { loadscheduleTemplates } from './api';
import ErrorMessageScheduleTemplateContainer from './ErrorMessageScheduleTemplateContainer.vue';

export default {
  mixins: [dateFormetter],
  components: {
    Page,
    Pagination,
    Section,
    List,
    EmptyMessage,
    ErrorMessageScheduleTemplateContainer,
    PreloaderSection,
  },
  data() {
    return {
      scheduleTemplates: null,
      lastPage: null,
      loadScheduleTemplatesState: {
        isLoading: true,
        error: null,
      },
    };
  },
  computed: {
    filter() {
      return this.$route.query;
    },
  },
  watch: {
    filter(newValue) {
      this.load(newValue);
    },
  },
  created() {
    this.load(this.filter);
  },
  methods: {
    async load(filter) {
      try {
        const response = await loadscheduleTemplates(filter);
        this.scheduleTemplates = response.data.data;
        this.lastPage = response.data.last_page;
        this.loadScheduleTemplatesState.isLoading = false;
      } catch (error) {
        this.loadScheduleTemplatesState.error = error.response;
        this.loadScheduleTemplatesState.isLoading = false;
      }
    },
    isEmpty() {
      return _.isEmpty(this.scheduleTemplates);
    },
    onSearch(event) {
      if (event.target.value) {
        const filter = { ...this.filter, q: event.target.value };
        this.$router.replace({ query: { ...filter } });
      }
    },
    clearSearch() {
      const filter = null;
      this.$router.replace({ query: { ...filter } });
    },
    isShowPagination() {
      return this.lastPage > 1;
    },
    getCategoryName(categoryTerm) {
      return _.get(categoryTerm, 'name', 'ไม่มีหมวดหมู่');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
</style>
